import {
  Button,
  Center,
  Group,
  SegmentedControl,
  Switch,
  Tooltip,
} from "@mantine/core";
import { createStyles } from "@mantine/emotion";
import {
  IconHandClick,
  IconHandMove,
  IconHomeHand,
  IconMarquee,
  IconPointer,
  IconPolygon,
  IconZoomIn,
  IconZoomOut,
  IconZoomOutArea,
  IconZoomPan,
} from "@tabler/icons-react";
import React from "react";
import { ApprovalLayoutTypes } from "utils/constants";

import { logger } from "utils/logger";
import { ApprovalEventTypes } from "./AssetViewer";

const useStyles = createStyles((theme) => ({
  container: {
    padding: "3px 10px",
    // paddingRight:0,
    // background:theme.colorScheme === 'dark'?theme.colors.dark[9]:theme.white,
    // borderRadius:theme.radius.sm,
  },
  col: {
    padding: 0,
  },
  tabContent: {
    padding: theme.spacing.xs,
    paddingTop: 0,
  },
}));

const ImageControlToolbar = ({
  settings,
  settingsChange,
  onControlsClick,
  size = "md",
  instanceId = "openseadragon",
}) => {
  const { classes } = useStyles();
  // const theme = useMantineTheme();

  logger.log("+++++++++++++++CHANGE", settings);

  /*const onLayoutChange = (val) => {
      const tmpSettings = {...settings,layoutType:val};
      settingsChange(ApprovalEventTypes.SETTINGS_CHANGE,tmpSettings);
    }

    const onSliderChange = useCallback((val,settings) => {
      logger.log(val)
      if(val !== settings.thumbnailSize){
        const tmpSettings = {...settings,thumbnailSize:val};
        settingsChange(ApprovalEventTypes.SETTINGS_CHANGE,tmpSettings);
      }
      
    },[settings]);*/

  const onCommentClick = (val) => {
    logger.log(val);
    const tmpSettings = { ...settings, annotationType: val };
    settingsChange(ApprovalEventTypes.SETTINGS_CHANGE, tmpSettings);
  };

  const onSyncZoomPanToggleClick = (val) => {
    const tmpSettings = { ...settings, syncZoomPan: val };
    if (settingsChange) {
      settingsChange(ApprovalEventTypes.SETTINGS_CHANGE, tmpSettings);
    }
  };

  return (
    <Group
      style={{ width: "auto" }}
      className={classes.container}
      gap={"xs"}
      justify="center"
    >
      <div id="toolbarDiv"></div>
      <div style={{ flex: 1, justifyItems: "center" }}>
        <Button.Group>
          <Tooltip label="Zoom In (+ key)" position="bottom" size={"sm"}>
            <Button id={`${instanceId}-zoom-in`} size="xs" variant="default">
              <IconZoomIn size={16} />
            </Button>
          </Tooltip>
          <Tooltip label="Zoom Out (- key)" position="bottom">
            <Button id={`${instanceId}-zoom-out`} size="xs" variant="default">
              {" "}
              <IconZoomOut size={16} />
            </Button>
          </Tooltip>
          <Tooltip label="Zoom All (0 key)" position="bottom">
            <Button
              id={`${instanceId}-home`}
              size="xs"
              variant="default"
              title="Zoom All"
            >
              <IconZoomOutArea size={16} />
            </Button>
          </Tooltip>
          {/* <Tooltip label="Add Comment (hold shift + drag)" position='bottom' onClick={() => onCommentClick()}>
                <Button size='xs' variant="default"> <IconMarquee size={16} /></Button>
              </Tooltip> */}
        </Button.Group>
      </div>

      {settings.layoutType === ApprovalLayoutTypes.COMPARE ? (
        <Switch
          ml={"xs"}
          size="xs"
          label="Sync navigation"
          checked={settings.syncZoomPan}
          onChange={(event) =>
            onSyncZoomPanToggleClick(event.currentTarget.checked)
          }
        />
      ) : null}

      {settings.isCommenting === true ? (
        <SegmentedControl ml={"xs"}
          value={settings.annotationType}
          onChange={onCommentClick}
          data={[
            {
              value: "PAN",
              label: (
                <Center title="Zoom and Pan and Selection mode">
                  <IconZoomPan size={16} />
                  {/* <Box ml={10}>Preview</Box> */}
                </Center>
              ),
            },
            {
              value: "POLYGON",
              label: (
                <Center title="Polygon Annotation">
                  <IconPolygon size={16} />
                  {/* <Box ml={10}>Preview</Box> */}
                </Center>
              ),
            },
            {
              value: "RECTANGLE",
              label: (
                <Center title="Rectangle Annotation">
                  <IconMarquee size={16} />
                </Center>
              ),
            },
          ]}
        />
      ) : null}

      {/* onClick={() => {logger.log('clicked'); onControlsClick(ApprovalImageToolbarModes.ZOOM_RESET)}}  */}
    </Group>
  );
};

export default ImageControlToolbar;
